<template>
  <div>
    <a-modal width="650px" title="目录选择" v-model:visible="visible">
      <br />

      <!-- directory\
      

         
      :selectable="true"
         :checkStrictly="false"
             :showLine="true"
             checkable
      -->
      <a-directory-tree
        checkable
        :load-data="onLoadData"
        :showLine="true"
        :checkStrictly="true"
        :replaceFields="replaceFields"
        :tree-data="treeData"
        v-model:checkedKeys="checkedKeys"
        :selectable="false"
      >
      </a-directory-tree>
      <template v-slot:footer>
        <a-button key="back" @click="handleCancel">取消</a-button>
        <a-button
          :loading="confirmLoading"
          key="submit"
          type="primary"
          @click="handleOk"
          >确定</a-button
        >
      </template>
    </a-modal>
  </div>
</template>

<script>
import { currentUserFilePath } from "@/api/system.js";
const treeData = [
  {
    Name: "parent 1",
    key: "0-0",
    Path: "/path",
  },
  {
    Name: "parent 2",
    key: "0-1",
    Path: "/path",
  },
];

export default {
  data() {
    return {
      confirmLoading: false,
      visible: false,
      treeData: treeData,
      checkedPath: "",
      checkedKeys: [],
      replaceFields: {
        title: "Name",
      },
      selectPath: "",
    };
  },
  computed: {
    groupId: JSON.parse(localStorage.getItem("westCurrentRole")).teamId,
    username() {
      return JSON.parse(localStorage.getItem("westUserInfo")).username;
    },
  },
  watch: {
    checkedKeys(val) {
      if (val.checked.length > 1) {
        // val.checked =   [val.checked[1]]
        val.checked.splice(0, 1);
        // let tmp =  val.checked[1]
        // val.checked[0] =  tmp

        //val.halfChecked = val.checked.shift()
      }
    },
  },
  mounted() {
    currentUserFilePath(this.groupId, "/", this.username).then(({ data }) => {
      data.Items.forEach((element) => {
        if (!element.is_dir) {
          element.isLeaf = true;
          element.disabled = true;
        } else {
        }

        if (element.Path?.includes(".s")) {
          element.disabled = true;
        }

        element.key = "/" + element.Name;
        //element.key = element.Name + '-' + Date.now()
      });

      this.treeData = data.Items;
      console.log(this.treeData);
    });
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    handleCancel() {
      this.close();
    },
    handleOk() {
      console.log(this.checkedKeys);
      this.selectPath = this.checkedKeys.checked[0];
      this.$emit("update", this.selectPath);
      this.close();
    },
    onLoadData(treeNode) {
      return new Promise((resolve) => {
        if (treeNode.dataRef.children) {
          resolve();
          return;
        }
        let path = treeNode.dataRef.Path;
        //let path = treeData
        currentUserFilePath(this.groupId, path, this.username)
          .then(({ data }) => {
            data.Items.forEach((element) => {
              if (!element.is_dir) {
                element.isLeaf = true;
                element.disabled = true;
              } else {
              }
              element.value = element.name;
              element.key = path + "/" + element.Name;
              // element.key = element.Name + '-' + Date.now()
              //element.key = Date.now()
            });

            console.log(data.Items);
            treeNode.dataRef.children = [...data.Items];
            resolve();
            //this.treeData.value = [...this.treeData.value]
          })
          .catch((e) => {
            console.log(e);
            resolve();
            // treeNode.dataRef.children = null
            // reject();
          });
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.anticon svg {
  color: burlywood;
}
</style>
